// Utils
import { updateElement } from '../actions/elementActions';
import { sendAmplitudeEvent } from '../../analytics/amplitudeService';

// Constants
import { EVENT_TYPE_NAMES } from '../../../common/analytics/amplitudeEventTypesUtil';
import { AMPLITUDE_USER_PROPS, TRACKED_FEATURES } from '../../../common/analytics/statsConstants';
import { ELEMENT_UPDATE_TYPE } from '../../../common/elements/elementConstants';

export const setTaskCompletion =
    ({ id, isComplete, transactionId }) =>
    (dispatch) => {
        isComplete &&
            sendAmplitudeEvent({
                eventType: EVENT_TYPE_NAMES.CHECKED_CHECKLIST,
                userProperties: {
                    [AMPLITUDE_USER_PROPS.FEATURE]: {
                        [TRACKED_FEATURES.CHECKLIST]: true,
                        [TRACKED_FEATURES.CHECKED_CHECKLIST]: true,
                    },
                },
            });

        return dispatch(
            updateElement({
                id,
                updateType: ELEMENT_UPDATE_TYPE.TOGGLE_COMPLETION,
                changes: { isComplete },
                transactionId,
            }),
        );
    };
